<template>
  <b-sidebar
    id="add-new-sidebar"
    :visible="isAddNewSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetData"
    @change="(val) => $emit('update:is-add-new-sidebar-active', val)"
  >

    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Add New')}}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>
      <div class="loading_page" v-if="requestStatus">
        <orbit-spinner
            :animation-duration="1000"
            :size="100"
            :color="'#0e96b1'"
        />
      </div>

      <info-form :data=data :errors=errors @onSubmit=onSubmit />
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
  BFormTextarea
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import InfoForm from '../form'
import client from '../client'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    OrbitSpinner,
    flatPickr,
    InfoForm
  },
  directives: {
    Ripple,
  },
  model: {
    prop: ['isAddNewSidebarActive'],
    event: ['update:is-add-new-sidebar-active', 'refetch-data'],
  },
  props: {
    isAddNewSidebarActive: {
      type: Boolean,
      required: true,
    }
  },
  setup(props, { emit }) {

    const blankData = {
      name: '',
      camp_leave: '00:00:00',
      camp_back:'00:00:00'
    }

    const errors = ref({})

    const requestStatus = ref(false)

    const data = ref(blankData)

    const resetData = () => {
      data.value = blankData
    }

    const onSubmit = () => {

      requestStatus.value = true
      errors.value = {}

      client.add(data.value)
        .then(() => {
          requestStatus.value = false
          emit('refetch-data')
          emit('update:is-add-new-sidebar-active', false)
        }).catch(res => {
          requestStatus.value = false
          if (res.response.status === 422) {
            errors.value = res.response.data.errors}
           console.log(res.response.data)
          }
      )
    }
    return {
      data,
      onSubmit,
      resetData,
      requestStatus,
      errors
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
#add-new-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
